import React, {memo, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import Grid from "@mui/material/Grid";
import Api from "../../utils/api";

const TemplateList = (props) => {

    const { list, onChange } = props;
    const [options, setOptions] = useState([]);
    const [templateList, setTemplateList] = useState([])




    useEffect(() => {

        handleMarketerList()

    } ,[])

    const handleMarketerList = (e,value) => {
        new Api().get('/contract_template/autocomplete' , {
            form: "contract_template_auto_complete",
            title: e?.target?.value ?? ""
        } ,false).then((response) => {
            if (typeof response !== "undefined") {
                setTemplateList(response);
            }
        })
    }


    return(
        <>
            {
                <Grid item={true} xs={12} sm={12}>
                <Autocomplete
                    autoComplete={'off'}
                    onChange={((event, value) => onChange(value))}
                    options={templateList.details}
                    getOptionLabel={(option) => option.title}
                    renderInput={(params) =>
                        <TextField
                            autoComplete={"off"}
                            {...params}
                            fullWidth
                            name='period_id'
                            margin={"dense"}
                            label="قالب مورد نظر"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={((event, value) => handleMarketerList(event, value))}
                        />
                    }
                />
            </Grid>
            }
        </>
    )
}

export default memo(TemplateList);